export default {
    title: 'Xcontact client',
    badge: 'Badge',
    close: 'Close',
    pesquisarAtendimentos: 'search service',
    resultadoPesquisa: 'Search result',
    isRequired: 'Is required',
    atendimentosDoCliente: 'Customer service',
    atendimentosAtivos: 'Active services',
    ultimosAtendimentos: 'Last services',
    indisponivel: 'Unavailable',
    fraseEncerramento: 'Do you want to end this service ?',
    fraseDeleteMsg: `Do you want to delete this message?`,
    legenda: `Caption`,
    mensagemApagada: `Message deleted`,
    pesquisarContatos: 'Search contacts',
    atendimentos: 'Services',
    ligacoes: 'Calls',
    historico: 'Historic',
    contatos: 'Contacts',
    minhasFilas: 'My queues',
    fraseInicial: 'The complete solution for managing multi- channel service flows!',
    classificacao: 'Classification',
    classificar: 'Classify',
    cancelar: 'Cancel',
    subClassificacao: 'Sub Classification',
    observacao: 'Observation',
    sim: 'Yes',
    nao: 'No',
    novaLigacao: 'New call',
    discar: 'Dial',
    ok: 'Ok',
    anexar: `Attach`,
    digiteAqui: `type here`,
    fraseNenhumaFilaVoz: 'You are not registered in any Voice queue',
    fraseNenhumaFilaEmail: 'You are not registered in any Email queue',
    fraseNenhumaFilaWhatsApp: 'You are not registered in any WhatsApp queue',
    transferencia: 'Transfer',
    transferir: 'Transfer',
    novoEmail: 'New Email',
    novoWhatsApp: 'New WhatsApp',
    continuar: 'Continue',
    encerrarAtendimento: `Close service`,
    classificarAtendimento: `Classify service`,
    transferirAtendimento: `Transfer service`,
    adicionarArquivos: `Add files`,
    desligar: 'Hangup',
    filaUnica: `Single queue`,
    pausar: 'Pause',
    removerPausa: 'Remove pause',
    desativar: 'Disable',
    ativar: 'Enable',
    ligacoesAtivas: 'Actives calls',
    fraseSelecioneLigacao: 'Select a call or enter the destination',
    informeUmNumero: 'Enter a number',
    tipo: 'Type',
    configuracao: 'Configuration',
    enderecoXcontact: 'Xcontact address',
    salvar: 'Save',
    senha: 'Password',
    entrar: 'Login',
    usuario: 'User',
    idioma: 'Language',
    login: {
        title: 'Login',
        name: 'Name',
        password: 'Password',
        btLogin: 'Login',
        loginFail: 'Username or password is invalid',
    },
    dataIterator: {
        noResultsText: 'No data found',
        loadingText: 'Loading items...',
    },
    dataTable: {
        itemsPerPageText: 'Rows per page:',
        ariaLabel: {
            sortDescending: ': Ordenado decrescente. Ative para remover a ordenação.',
            sortAscending: ': Ordenado crescente. Ative para ordenar decrescente.',
            sortNone: ': Não ordenado. Ative para ordenar crescente.',
        },
        sortBy: 'Ordenar por',
    },
    dataFooter: {
        itemsPerPageText: 'Itens por página:',
        itemsPerPageAll: 'Todos',
        nextPage: 'Próxima página',
        prevPage: 'Página anterior',
        firstPage: 'Primeira página',
        lastPage: 'Última página',
        pageText: '{0}-{1} de {2}',
    },
    datePicker: {
        itemsSelected: '{0} selecionado(s)',
    },
    noDataText: 'Não há dados disponíveis',
    carousel: {
        prev: 'Visão anterior',
        next: 'Próxima visão',
        ariaLabel: {
            delimiter: 'Slide {0} de {1} do carrossel',
        },
    },
    calendar: {
        moreEvents: 'Mais {0}',
    },
    fileInput: {
        counter: '{0} arquivo(s)',
        counterSize: '{0} arquivo(s) ({1} no total)',
    },
    timePicker: {
        am: 'AM',
        pm: 'PM',
    },
    queue: "Queue",
    fila: "queue",
    queues: "Queues",
    agentes: "Agents",
    DispositivoDeEntrada: "Input device",
    DispositivoDeSaida: "Output device",
    DispositivoDeAlarme: "Ring device",
    dadosDeIntegracao: "Integration data",
    nome: "name",
    assunto: "subject ",
    instancia: "instance",
    numero: "number",
    ajusteDeAudio: "Audio Settings",
    agente: "agent",
    pesquiseAqui: "search here",
    reproduzirAudioNasNotificaçõesDeMensagens: "play audio in message notifications?",
    emAtendimento: "In service",
    finalizado: "Finished",
    disponivel: 'Available',
    responder: 'reply',
    apagarMensagem: 'delete message',
    responderATodos: 'Reply all',
    encaminhar: 'Forward',
    contato: 'contact',
    data: 'date',
    sentido: 'direction',
    visualizar: 'view',
    ligar: 'call',
    entrantes: 'Incoming',
    saintes: 'Outgoing',
    atendidas: 'Answered',
    naoAtendidas: 'Not answered',
    sainte: 'Outgoing',
    entrante: 'Incoming',
    habilitarNotificacaoes: 'enable notifications?',
    dadosIndisponiveis: 'No data',
    obrigaClassificarLigacao: 'Force the classification of calls',
    autoAtendimento: 'Accept call automatically',
    selecioneohorario: 'Select an hour',
    descricao: 'description',
    addUserConference: 'Add participant',
    Alerta: 'Warning',
    ultimoAgente: 'last agent',
    Encerrado: 'Closed',
    Entrou: 'In service',
    PreAtendimento: 'Bot',
    ConexaoPerdida: 'Connection lost',
    DesconectadoDoServidor: "Disconnected",
    ConexaoEstabelecida: "Connected",
    ConectadoAoServidor: "Connection established",
    FilaDeEspera: "Waiting queue",
    editarContato: "Edit contact",
    Agendamentos: 'Scheduling',
    Naofoipossivelcompletaraligacao: 'Unable to complete the call',
    Naofoipossivelcompletaraligacao: 'The number its busy',
    fraseAoFechar1: 'Make sure there are no outstanding services.',
    fraseAoFechar2: 'On close the system the agent  will be removed of all queues!',
    fraseCampoObrigatorio: 'Item is required!',
    transferir: "Transfer",
    configuracoesDeVoz: 'Audio settings',
    urlIntegracao: 'Integration url',
    frasePerdaConexao: 'Conection lost',
    enviarTemplate: 'Send template',
    salvarCredenciais: 'Save credentials'











}
